import {SelectItem} from "primeng/api";

export class SelectableList {
  private listElements : SelectItem[];
  constructor (values : string[]) {
    this.listElements = [];
    for (let i : number = 0; i < values.length; i++) {
      this.listElements.push(<SelectItem>{label: values[i], value : values[i]});
    }
  }

  public getListElements() : SelectItem[] {
    return this.listElements;
  }
}
